import {
    Component,
    ContentChild,
    ElementRef,
    EventEmitter,
    inject,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectOption } from '@shared/components/form/form-select/select-option.model';
import { ValidationMessagePipe } from '@shared/pipes';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'form-select',
    templateUrl: './form-select.component.html',
    styleUrls: ['./form-select.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatSelectModule,
        MatButtonModule,
        ReactiveFormsModule,
        ValidationMessagePipe,
        MatIconModule,
        TranslatePipe,
    ],
    host: {
        class: 'form-select',
    },
})
export class FormSelectComponent implements ControlValueAccessor, OnInit {
    @Input()
    public label = '';

    @Input()
    public placeholder = '';

    @Input()
    public multiple = false;

    @Input()
    public options: SelectOption[] = [];

    @Input()
    public translateOptions = false;

    @Input()
    public appearance: 'fill' | 'outline' = 'fill';

    @Output()
    public readonly prefixClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

    @ContentChild('prefix')
    public prefixElement: ElementRef;

    public selectControl: FormControl;

    private readonly ngControl: NgControl = inject(NgControl, { self: true, optional: true });

    constructor() {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    public ngOnInit(): void {
        this.selectControl = this.ngControl.control as FormControl;
    }

    public handlePrefixClick(event: MouseEvent): void {
        event.stopPropagation();
        this.prefixClick.emit(event);
    }

    public registerOnChange(): void {}

    public registerOnTouched(): void {}

    public writeValue(): void {}
}
